// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RQ2LHtMBxfuNRBdPfBuQ {
  display: inline-block;
  position: relative;
  width: 100%;
  height: 30px;
  margin: 0;
  padding: 0;
  background-image: linear-gradient(#6b6f74, #6b6f74);
  background-position: left center;
  background-size: 100% 2px;
  background-repeat: no-repeat;
  background-color: transparent;
}
.bL73rWarCjVE466zkG2w {
  background-image: linear-gradient(red, red);
}

.KHB58rGt7j02Vv8bSGo1 {
  box-sizing: border-box;
  background-clip: padding-box;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  background: transparent;
  border: none;
  vertical-align: top;
  outline: none;
  line-height: 1;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: linear-gradient(#bbb, #bbb);
  background-position: left center;
  background-size: 0% 2px;
  background-repeat: no-repeat;
  height: 30px;
  position: relative;
  z-index: 1;
  width: 100%;
}
.emkU07ZAGE9U9Op28Ms4::-webkit-slider-thumb {
  background: rgb(255, 211, 211);
}
.emkU07ZAGE9U9Op28Ms4::-moz-range-thumb {
  background: rgb(255, 211, 211);
}
.emkU07ZAGE9U9Op28Ms4::-ms-thumb {
  background: rgb(255, 211, 211);
}
.KHB58rGt7j02Vv8bSGo1.TfsvSTINg60PJrywHcz7::-webkit-slider-thumb {
  border: 1px solid #ccc;
  background: #fff;
}
.KHB58rGt7j02Vv8bSGo1.TfsvSTINg60PJrywHcz7::-moz-range-thumb {
  border: 1px solid #ccc;
  background: #fff;
}
.KHB58rGt7j02Vv8bSGo1.TfsvSTINg60PJrywHcz7::-ms-thumb {
  border: 1px solid #ccc;
  background: #fff;
}

.KHB58rGt7j02Vv8bSGo1::-moz-range-track {
  position: relative;
  border: none;
  background: none;
  box-shadow: none;
  top: 0;
  margin: 0;
  padding: 0;
}

.KHB58rGt7j02Vv8bSGo1::-ms-track {
  position: relative;
  border: none;
  background-color: #6b6f74;
  height: 0;
  border-radius: 50%;
}

.KHB58rGt7j02Vv8bSGo1::-webkit-slider-thumb {
  cursor: pointer;
  position: relative;
  height: 28px;
  width: 28px;
  background-color: #4c68a4;
  border: none;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.25), 0 3px 2px rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  -webkit-appearance: none;
  appearance: none;
  top: 0;
  z-index: 1;
}

.KHB58rGt7j02Vv8bSGo1::-moz-range-thumb {
  cursor: pointer;
  position: relative;
  height: 28px;
  width: 28px;
  background-color: #4c68a4;
  border: none;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.25), 0 3px 2px rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  margin: 0;
  padding: 0;
}

.KHB58rGt7j02Vv8bSGo1::-ms-thumb {
  cursor: pointer;
  position: relative;
  height: 28px;
  width: 28px;
  background-color: #4c68a4;
  border: none;
  box-shadow: 0 0 1px 0 rgba(0, 0, 0, 0.25), 0 3px 2px rgba(0, 0, 0, 0.25);
  border-radius: 50%;
  margin: 0;
  padding: 0;
  top: 0;
}

.KHB58rGt7j02Vv8bSGo1::-ms-fill-lower {
  height: 2px;
  background-color: #bbb;
}

.KHB58rGt7j02Vv8bSGo1::-ms-tooltip {
  display: none;
}

.KHB58rGt7j02Vv8bSGo1:disabled {
  opacity: 1;
  pointer-events: none;
}

.yOxOvP875hwcSNyNazqV {
  pointer-events: none;
  top: 0;
  left: 0;
  display: none;
  box-sizing: border-box;
  background-clip: padding-box;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  background: transparent;
  border: none;
  vertical-align: top;
  outline: none;
  line-height: 1;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: none;
  height: 30px;
  position: absolute;
  z-index: 0;
  width: 100%;
}

.obO3sDRv5QFiPDZQ9g_A {
  opacity: 0.3;
  cursor: default;
  pointer-events: none;
  pointer-events: none;
}

.g8Kynj10JEoXY6mElGBj {
  display: flex;
  color: #4c68a4;
  justify-content: space-between;
}

.bKTNDYucaVUd9dOJg1tc {
  display: flex;
  color: #4c68a4;
  justify-content: center;
  min-height: 5px;
}

.aLfwZRwvCr9bt4icieh_ {
  display: block;
  background-color: rgba(76, 104, 164, 0.2);
  color: #4c68a4;
  border: none;
  text-align: center;
  margin-top: 3px;
  margin-left: 10px;
  margin-right: 10px;
  padding: 3px;
}
.aLfwZRwvCr9bt4icieh_.TfsvSTINg60PJrywHcz7 {
  background-color: #fee;
}`, "",{"version":3,"sources":["webpack://./packages/react-hook-schema/standard/src/lib/common/slider.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,mDAAA;EACA,gCAAA;EACA,yBAAA;EACA,4BAAA;EACA,6BAAA;AACF;AACE;EACE,2CAAA;AACJ;;AAEA;EACE,sBAAA;EACA,4BAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,6CAAA;EACA,gCAAA;EACA,uBAAA;EACA,4BAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AACF;AACI;EACE,8BAAA;AACN;AACI;EACE,8BAAA;AACN;AACI;EACE,8BAAA;AACN;AAGI;EACE,sBAAA;EACA,gBAAA;AADN;AAGI;EACE,sBAAA;EACA,gBAAA;AADN;AAGI;EACE,sBAAA;EACA,gBAAA;AADN;;AAKA;EACE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;AAFF;;AAIA;EACE,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,SAAA;EACA,kBAAA;AADF;;AAGA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,wEAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EACA,wBAAA;EACA,gBAAA;EACA,MAAA;EACA,UAAA;AAAF;;AAEA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,wEAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;AACF;;AACA;EACE,eAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,wEAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,MAAA;AAEF;;AAAA;EACE,WAAA;EACA,sBAAA;AAGF;;AADA;EACE,aAAA;AAIF;;AAFA;EACE,UAAA;EACA,oBAAA;AAKF;;AAHA;EACE,oBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;EACA,sBAAA;EACA,4BAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,cAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,wBAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;AAMF;;AAJA;EACE,YAAA;EACA,eAAA;EACA,oBAAA;EACA,oBAAA;AAOF;;AALA;EACE,aAAA;EACA,cAAA;EACA,8BAAA;AAQF;;AANA;EACE,aAAA;EACA,cAAA;EACA,uBAAA;EACA,eAAA;AASF;;AAPA;EACE,cAAA;EACA,yCAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;AAUF;AATE;EACE,sBAAA;AAWJ","sourceRoot":""}]);
// Exports
export var range = `RQ2LHtMBxfuNRBdPfBuQ`;
export var range__error = `bL73rWarCjVE466zkG2w`;
export var range__input = `KHB58rGt7j02Vv8bSGo1`;
export var range__input__error = `emkU07ZAGE9U9Op28Ms4`;
export var range__input__unselected = `TfsvSTINg60PJrywHcz7`;
var _1 = `yOxOvP875hwcSNyNazqV`;
export { _1 as "range__focus-ring" };
var _2 = `obO3sDRv5QFiPDZQ9g_A`;
export { _2 as "range--disabled" };
export var range__label__top = `g8Kynj10JEoXY6mElGBj`;
export var range__label__bottom = `bKTNDYucaVUd9dOJg1tc`;
export var range__label__selected = `aLfwZRwvCr9bt4icieh_`;
export default ___CSS_LOADER_EXPORT___;
